import { createRoute, createVirtualRoute } from "@/router/methods/helpers/create-route";
import { routeData } from "@/router/constants/routes";

import { vehicleBeforeEnter } from "@/router/methods/route-logic/vehicle";
import { quoteBeforeEnter } from "@/router/methods/route-logic/quote";
import { insuranceCompanyBeforeEnter } from "@/router/methods/route-logic/insurance-company";
import { landingBeforeEnter } from "@/router/methods/route-logic/landing";
import { heritageBeforeEnter } from "@/router/methods/route-logic/heritage";
import { loadSessionBeforeEnter } from "@/router/methods/route-logic/load-session";
import { autoRouteBeforeEnter } from "@/router/methods/route-logic/auto-route";
import { errorBeforeEnter } from "@/router/methods/route-logic/error";
import { restartBeforeEnter } from "@/router/methods/route-logic/restart";
import { paymentMethodBeforeEnter } from "@/router/methods/route-logic/payment-method";
import { paymentBeforeEnter } from "@/router/methods/route-logic/payment";
import { serviceLocationBeforeEnter } from "@/router/methods/route-logic/service-location";
import { adyenReturnBeforeEnter } from "@/router/methods/route-logic/adyen-return";
import { scheduleBeforeEnter } from "@/router/methods/route-logic/schedule";
import { duplicateCheckBeforeEnter } from "@/router/methods/route-logic/duplicate-check";
import { policyInfoBeforeEnter } from "@/router/methods/route-logic/policy-info";
import { policyVehicleBeforeEnter } from "@/router/methods/route-logic/policy-vehicle";
import { endorsementsBeforeEnter } from "@/router/methods/route-logic/endorsements";
import { coverageStatementBeforeEnter } from "@/router/methods/route-logic/coverage-statement";
import { recalibrationInfoBeforeEnter } from "@/router/methods/route-logic/recalibration-info";

export const routes = [
    // Non-virtual pages.
    createRoute(routeData.VEHICLE, vehicleBeforeEnter),
    createRoute(routeData.VEHICLE_DAMAGE),
    createRoute(routeData.ESTIMATE),
    createRoute(routeData.ADDRESS_LOOKUP),
    createRoute(routeData.VIN_LOOKUP),
    createRoute(routeData.LICENSE_PLATE_LOOKUP),
    createRoute(routeData.SERVICE_ZIP),
    createRoute(routeData.ADDRESS_VEHICLES),
    createRoute(routeData.VEHICLE_PARTS),
    createRoute(routeData.PART_QUESTIONS),
    createRoute(routeData.MOLDING_QUESTIONS),
    createRoute(routeData.CAPABILITY_QUESTIONS),
    createRoute(routeData.QUOTE, quoteBeforeEnter),
    createRoute(routeData.INSURANCE_COMPANY, insuranceCompanyBeforeEnter),
    createRoute(routeData.SERVICE_LOCATION, serviceLocationBeforeEnter),
    createRoute(routeData.SCHEDULE, scheduleBeforeEnter),
    createRoute(routeData.SCHEDULING),
    createRoute(routeData.CUSTOMER_DETAILS),
    createRoute(routeData.PAYMENT_METHOD, paymentMethodBeforeEnter),
    createRoute(routeData.PAYMENT, paymentBeforeEnter),
    createRoute(routeData.PAYMENT_PIA_RETURN),
    createRoute(routeData.PAYMENT_ADYEN),
    createRoute(routeData.CONFIRMATION),
    createRoute(routeData.RETURN_USER),
    createRoute(routeData.MOBILE_DETAILS),
    createRoute(routeData.POLICY_INFO, policyInfoBeforeEnter),
    createRoute(routeData.INSURANCE_DETAILS),
    createRoute(routeData.DUPLICATE_CHECK, duplicateCheckBeforeEnter),
    createRoute(routeData.POLICY_VEHICLE, policyVehicleBeforeEnter),
    createRoute(routeData.POLICY_DRIVER),
    createRoute(routeData.ENDORSEMENTS, endorsementsBeforeEnter),
    createRoute(routeData.POLICY_INFO_SUBMITTED),
    createRoute(routeData.COVERAGE_STATEMENT, coverageStatementBeforeEnter),
    createRoute(routeData.RECALIBRATION_INFO, recalibrationInfoBeforeEnter),
    createRoute(routeData.VERIFY_DETAILS),
    createRoute(routeData.BAILOUT),
    createRoute(routeData.BAILOUT_SUCCESS),
    // Virtual pages (resolve to a non-virtual page.)
    createVirtualRoute(routeData.LANDING, landingBeforeEnter),
    createVirtualRoute(routeData.HERITAGE, heritageBeforeEnter),
    createVirtualRoute(routeData.LOAD_SESSION, loadSessionBeforeEnter),
    createVirtualRoute(routeData.AUTO_ROUTE, autoRouteBeforeEnter),
    createVirtualRoute(routeData.ERROR, errorBeforeEnter),
    createVirtualRoute(routeData.RESTART, restartBeforeEnter),
    createVirtualRoute(routeData.PAYMENT_ADYEN_RETURN, adyenReturnBeforeEnter),
];
